import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Icon from '../../../../../atoms/Icon'

const useStyles = makeStyles((theme) => ({
  statusDisplay: ({ statusInfo, size }) => {
    const bg = statusInfo?.color
      ? statusInfo.color
      : 'inherit'

    return ({
      background: bg,
      width: `${size + 10}px`,
      height: `${size + 10}px`,
      display: 'inline-block',
      borderRadius: 'var(--border-radius-round)',
      borderWidth: statusInfo?.color ? '1px' : undefined,
      borderStyle: statusInfo?.color ? 'solid' : undefined,
      borderColor: statusInfo?.color ? statusInfo.color : undefined
    })
  },
  statusIcon: ({ statusInfo, size }) => {
    return {
      width: `${size + 10}px`,
      height: `${size + 10}px`,
      padding: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      '& svg': {
        fill: statusInfo?.color,
        stroke: statusInfo?.color
      }
    }
  },
  statusBg: ({ statusInfo }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    borderRadius: 'var(--border-radius-md)',
    background: statusInfo?.color ?? 'var(--color-neutral-300)',
    opacity: 0.2
  })
}))

function StatusDisplayBoardLayout ({ statusInfo, size, useIcon, hasBackground }) {
  const classes = useStyles({ statusInfo, size })
  if (useIcon && !!statusInfo?.icon) {
    return (
      <div className={classes.statusIcon}>
        {hasBackground && (
          <span className={classes.statusBg} />
        )}
        <Icon
          name={statusInfo.icon}
          customSize={size}
          color={statusInfo.color}
        />
      </div>
    )
  }
  return (
    <span className={classes.statusDisplay} title={statusInfo?.displayName} />
  )
}

StatusDisplayBoardLayout.propTypes = {
  statusInfo: PropTypes.object,
  size: PropTypes.number,
  useIcon: PropTypes.bool,
  hasBackground: PropTypes.bool
}

StatusDisplayBoardLayout.defaultProps = {
  size: 14,
  useIcon: false,
  hasBackground: false
}

export default StatusDisplayBoardLayout
